import React, { useEffect, useState } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { deleteSellingSource, getSellingSourceList, set, updateSellingSource } from "../publicationSlice";
import { validateFullName, startsWithSpace } from "../../../Utils/validators";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
import UpdatePopup from "../../../Component/updatePopup";
const EditSellingSource = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [isEdit, setIsEdit] = useState<Boolean>(false);
  const [sellingSourceList, setSellingSourceList] = useState<any>([]);
  const [sellingSourceName, setSellingSourceName] = useState<string>("");
  const [sellingSourceID, setSellingSourceID] = useState<string>("");
  const [sellingSourceStatus, setsellingSourceStatus] = useState<string>("");
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [deleteSellingSourceData, setDeleteSellingSourceData] = useState<any>();
  useEffect(() => {
    getData()
  }, []);

  const getData = () => {
    dispatch(
      getSellingSourceList({
        callback: (res: any) => {
          setSellingSourceList(res?.data);
          if (res?.status === "success") {
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        }
      })
    );
  };

  const handleEdit = (value: any) => {
    setIsEdit(true);
    setSellingSourceName(value?.name);
    setSellingSourceID(value?._id);
    setsellingSourceStatus(value?.status);
  };

  const onChangeSellingSource = (value: string) => {
    if (validateFullName(value) && !startsWithSpace(value)) {
      setSellingSourceName(value);
    }
  };

  const handleSubmit = () => {
    setIsEdit(true);
    const Payload = {
      name: sellingSourceName,
      status: sellingSourceStatus
    };
    dispatch(
      updateSellingSource({
        id: sellingSourceID,
        params: Payload,
        callback: (res: any) => {
          setIsEdit(false);
          getData()
          if (res?.status === "success") {
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };

  const handleDelete = (value: any) => {
    setIsDelete(true);
    setDeleteSellingSourceData(value);
  };
  const handleDeleteSource = (value: any) => {
    dispatch(
      deleteSellingSource({
        id: value?._id,
        callback: (res: any) => {
          if (res?.data?.status === "success") {
            setIsEdit(false);
            dispatch(showSnackbar({ message: res?.data?.msg, type: res?.data?.status }));
            setTimeout(() => {
              hideSnackbar();
              getData();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  }
  const handleGoBack = () => {
    setIsEdit(false);
  };

  const renderTable = () => {
    return (
      <AdminTable
        tableData={sellingSourceList ? sellingSourceList : []}
        pagename={"sellingSourceList"}
        tableHead={["S.N", "Source Name", "Action"]}
        handleEdit={(value: any) => handleEdit(value)}
        handleDelete={(value: any) => handleDelete(value)}
        edit={true}
      />
    );
  };
  const validation = () => {
    if (sellingSourceName === "") return true;
  }
  const renderEditMode = () => {
    return (
      <form>
        <div className="row align-items-center">
          <div className="col-md-6">
            <LabelInput labelName={"Selling Source Name"} />
            <div className="d-flex align-items-center">
              <div className="me-3 col-md-8">
                <InputField
                  key={"ex2"}
                  placeholder={"Enter Selling Source Name"}
                  setInputText={(value: any) => onChangeSellingSource(value)}
                  value={sellingSourceName}
                />
              </div>
              <div className="col-3 pt-2">
                <button type="button" className="submitBtn mb-3 w-100 font18 py-2" onClick={() => setIsUpdate(true)} disabled={validation()}>
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete Selling Source"}
          breadCrumb={""}
          isEditMode={isEdit}
          setisEditMode={setIsEdit}
          cancelEdit={() => handleGoBack()}
        />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius">
          {isEdit ? renderEditMode() : renderTable()}
        </div>
      </div>
      {/* Update Popup Start*/}
      <UpdatePopup
        open={isUpdate}
        closePopup={() => setIsUpdate(false)}
        title={"Update Selling Source"}
        message={<>Are you sure you want to Update SellingSource to <b>"{sellingSourceName}"</b></>}
        onUpdate={() => handleSubmit()} />
      {/* Update Popup End*/}

      {/* delete Popup Start*/}
      <UpdatePopup
        open={isDelete}
        closePopup={() => setIsDelete(false)}
        title={"Delete Selling Source"}
        message={<>Are you sure you want to delete <b>"{deleteSellingSourceData?.name}"</b> selling source?</>}
        onUpdate={() => handleDeleteSource(deleteSellingSourceData)} />
      {/* delete Popup End*/}
    </div>
  );
};

export default EditSellingSource;
